import React, { useEffect, useMemo, useState } from "react";
import { GAME_LIST } from "./helper";
import { useLocation, useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { loading, loadingDestroy } from "../../redux/action/action";
import useDeviceType from "../../hook/useDeviceType";

const GameSelect = ({ customScrollY }) => {
  const [fixed, setFixed] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const deviceType = useDeviceType();

  const defaultTab = useMemo(() => {
    return GAME_LIST.find((item) => item.link === location.pathname)?.text;
  }, [location.pathname]);

  const scrollSet = customScrollY ? customScrollY : 200;

  useEffect(() => {
    const handleScroll = (event) => {
      if (window.scrollY > scrollSet) {
        setFixed(true);
      } else {
        setFixed(false);
      }
    };

    if (deviceType !== "PC") {
      window.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (deviceType !== "PC") {
        window.removeEventListener("scroll", handleScroll);
      }
    };
  }, [deviceType]);

  return (
    <section className={`${fixed && "h-[77px]"}`}>
      <section
        className={`grid grid-cols-6 md:w-[500px] items-center ${
          fixed &&
          "fixed w-full top-[50px] bg-second-color z-[99] py-common-padding-x"
        }`}
      >
        {GAME_LIST.map((game, index) => {
          return (
            <div
              key={index}
              className={`${
                defaultTab === game.text &&
                "md:bg-main-color !text-second-color"
              } flex justify-center items-center cursor-pointer md:hover:bg-main-color md:hover:text-white md:border md:border-light-orange md:rounded-md text-light-orange md:mr-[10px] md:py-[6px] md:px-[25px]`}
              onClick={() => {
                dispatch(loading());
                setTimeout(() => {
                  navigate(game.link);
                  dispatch(loadingDestroy());
                }, 200);
              }}
            >
              <img
                className="w-[50px] md:hidden"
                src={game?.icon}
                alt={game.text}
              />
              <p className="mb-0 hidden md:block">{game.text}</p>
            </div>
          );
        })}
      </section>
    </section>
  );
};

export default GameSelect;
